import { render, staticRenderFns } from "./ArrobaMedellinSeeker.html?vue&type=template&id=61b488b2&scoped=true&external"
import script from "./ArrobaMedellinSeeker.vue?vue&type=script&lang=js"
export * from "./ArrobaMedellinSeeker.vue?vue&type=script&lang=js"
import style0 from "./ArrobaMedellinSeeker.scss?vue&type=style&index=0&id=61b488b2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b488b2",
  null
  
)

export default component.exports